import { useLazyQuery } from '@apollo/client'
import { GET_APPROVER_GROUPS } from 'queries/get-approver-groups-by-deal'
import {
  ApproverGroupsRequest,
  ApproverGroupsResponse,
} from 'ts/interfaces/approverGroup.interface'

export const useGetApproverGroups = () => {
  const [getApproverGroups, { data, loading, error }] = useLazyQuery<
    ApproverGroupsResponse,
    ApproverGroupsRequest
  >(GET_APPROVER_GROUPS, { fetchPolicy: 'no-cache' })

  const handleGetApproverGroups = async (dealId: number, decisionTypeCode: string) => {
    try {
      await getApproverGroups({
        variables: {
          approverGroupsByDealRequest: {
            dealId,
            decisionTypeCode,
          },
        },
      })
    } catch (error) {
      return error
    }
  }

  return {
    handleGetApproverGroups,
    loading,
    data: data?.approverGroupsByDeal.approverGroups,
    error,
  }
}
